import React from 'react';
import { LockIcon, MailCheckIcon, ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
export function FinalCta() {
  return <section className="w-full bg-inverse px-5 py-20 sm:py-24" data-id="element-95" data-mp="vhahy8me66yp">
      <div className="mx-auto max-w-2xl text-center" data-id="element-96" data-mp="19g0glsov0ep6">
        <h2 className="font-display text-[1.85rem] font-black leading-tight tracking-tight text-surface sm:text-[2.6rem]" data-id="element-97" data-mp="15ddjbc9f61kl">
          Prêt à faire entrer la musique dans{' '}
          <span className="italic text-primary-soft" data-id="element-98" data-mp="1jb228ejxeyn0">chaque classe&nbsp;?</span>
        </h2>
        <p className="mx-auto mt-4 max-w-md text-sm leading-relaxed text-surface/70 sm:text-base" data-id="element-99" data-mp="1eds66g217oq7">
          Arrêtez de planifier. Commencez à enseigner. Obtenez des résultats.
        </p>
        <div className="mt-8" data-id="element-100" data-mp="1o4db0l8atphk">
          <CtaButton label="Je veux Musique Prête™ maintenant" data-id="element-101" data-mp="1o67ojeh8qfbm" />
        </div>

        <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-[11px] font-semibold text-surface/55" data-id="element-102" data-mp="223w7ggrqzce1">
          <li className="flex items-center gap-1.5" data-id="element-103" data-mp="n5ujjv79jbdl">
            <LockIcon className="h-3.5 w-3.5 text-primary-soft" aria-hidden="true" data-id="element-104" data-mp="n75ovzgcwr6t" />
            Paiement sécurisé SSL
          </li>
          <li className="flex items-center gap-1.5" data-id="element-105" data-mp="s6iid31qgwid">
            <ShieldCheckIcon className="h-3.5 w-3.5 text-primary-soft" aria-hidden="true" data-id="element-106" data-mp="x2za07855t07" />
            30 jours de garantie
          </li>
          <li className="flex items-center gap-1.5" data-id="element-107" data-mp="1658gmm0ah28b">
            <MailCheckIcon className="h-3.5 w-3.5 text-primary-soft" aria-hidden="true" data-id="element-108" data-mp="162dv0r5jhbdb" />
            Livraison immédiate par email
          </li>
        </ul>
      </div>
    </section>;
}